<template>
  <li>
    <router-link
      :exact="exact"
      :class="$style.link"
      :active-class="$style.isActive"
      :to="{ name: route }"
    >
      <base-icon :class="$style.icon" :name="icon" themeSize="xx-large" />
      <span :class="$style.label">{{ label }}</span>
    </router-link>
  </li>
</template>

<script>
export default {
  name: 'LeftMenuItem',

  props: {
    exact: { Boolean },
    label: { String },
    icon: { String },
    route: { String }
  }
}
</script>

<style lang="scss" module>
.link {
  display: block;
  text-decoration: none;
  min-height: 40px;
  padding-left: spacing(4);
  padding-right: spacing(4);

  &:hover .icon,
  &:focus .icon {
    fill: $color-primary;
  }

  &:hover .label,
  &:focus .label {
    color: $color-primary-light;
  }

  &.isActive {
    padding-left: spacing(3.5);
    border-left: 4px solid $color-primary-light;
    background-image: linear-gradient(
      to right,
      transparent,
      rgba(0, 143, 202, 0.15)
    );
  }
}

.icon {
  transition: fill 0.2s;
  margin-right: spacing(3);
  fill: $color-icons;

  .isActive & {
    fill: $color-primary;
  }
}

.label {
  line-height: 40px;
  font-size: $size-medium;
  font-weight: $weight-regular;
  color: $color-copy;
  transition: color 0.2s;

  .isActive & {
    color: $color-primary-light;
    font-weight: $weight-semibold;
  }
}
</style>
